import styled from '@emotion/styled';

/**
 * Стили для текста над кальулятором в анкете
 */
export const Root = styled.div`
  padding-top: 1rem;
`;
